var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-270.000000, -3533.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M950.2,4171.8L826,4296c-120.1-73.8-221.2-174.9-295-295l124.2-124.2             c-55.2-102.3-86.6-219.4-86.6-343.8H270c0,565.4,458.3,1024,1024,1024v-298.7C1169.6,4258.3,1052.5,4226.9,950.2,4171.8z             M359.6,3618.3h128.3c9,84.9,31.2,165.8,64.3,240.9l-96.3,96.2C403.9,3852.6,370.5,3738.7,359.6,3618.3z M1208.7,4467.4             c-120.4-10.9-234.3-44.3-337.2-96.3l96.3-96.3c75.1,33.1,156,55.3,240.9,64.3L1208.7,4467.4L1208.7,4467.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1fb86497dc2ec465cf2c613efda8c8ed.svg";
export { ForwardRef as ReactComponent };